"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../Button");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Loading = require("../Loading");

var _wrappers = require("../../wrappers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-image: radial-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding 0px 50px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  z-index: 100000;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n  transition: 1s;\n  &.show {\n    pointer-events: auto;\n    opacity: 1;\n    overflow-x: hidden;\n    overflow-y: visible !important;\n  }\n  &.hide {\n    opacity: 0;\n  }\n  div.body {\n    position: relative;\n    transition: 1s;\n  }\n  &.show div.body {\n    bottom: 0%;\n  }\n  &.hide div.body {\n    bottom: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalContainerBase = _styledComponents["default"].div(_templateObject());

var ModalContainer = (0, _styledComponents["default"])(ModalContainerBase)(_templateObject2());
var PositionedModalContainer = (0, _styledComponents["default"])(ModalContainerBase)(_templateObject3());

var LoadingContainer = _styledComponents["default"].div(_templateObject4());

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      onResolve: null,
      onReject: null,
      loading: false
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.show && !oldProps.show) {
        this.setState({
          onResolve: null,
          onReject: null
        });
      }
    }
  }, {
    key: "onHide",
    value: function onHide() {
      this.props.onHide();
    }
  }, {
    key: "onAction",
    value: function onAction(e, _ref) {
      var _this2 = this;

      var action = _ref.action,
          onResolve = _ref.onResolve,
          onReject = _ref.onReject;
      this.setState({
        loading: true
      });
      Promise.resolve(action(e)).then(function (res) {
        _this2.setState({
          loading: false
        });

        if (onResolve) {
          _this2.onResolve(res, onResolve);
        } else if (_this2.props.hideOnAction) {
          _this2.onHide();
        }
      })["catch"](function (e) {
        console.log("<AvlModal.onAction> ERROR:", e);

        _this2.setState({
          loading: false
        });

        Boolean(onReject) && _this2.onReject(e, onReject);
      });
    }
  }, {
    key: "onResolve",
    value: function onResolve(res, comp) {
      this.setState({
        onResolve: {
          res: res,
          comp: comp
        }
      });
    }
  }, {
    key: "onReject",
    value: function onReject(error, comp) {
      this.setState({
        onReject: {
          error: error,
          comp: comp
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          show = _this$props.show,
          actions = _this$props.actions,
          _this$state = this.state,
          onResolve = _this$state.onResolve,
          onReject = _this$state.onReject,
          filteredActions = actions.filter(function (a) {
        return a.show !== false;
      }),
          Container = this.props.usePositioned ? PositionedModalContainer : ModalContainer;
      return /*#__PURE__*/_react["default"].createElement(Container, {
        className: "".concat(show ? "show" : "hide")
      }, !this.state.loading ? null : /*#__PURE__*/_react["default"].createElement(LoadingContainer, null, /*#__PURE__*/_react["default"].createElement(_Loading.ScalableLoading, null)), /*#__PURE__*/_react["default"].createElement(BodyContainer, null, /*#__PURE__*/_react["default"].createElement(ContentContainer, {
        className: "rounded py-2 px-3"
      }, onResolve ? /*#__PURE__*/_react["default"].createElement(onResolve.comp, {
        res: onResolve.res
      }) : onReject ? /*#__PURE__*/_react["default"].createElement(onReject.comp, {
        error: onReject.error
      }) : this.props.children), /*#__PURE__*/_react["default"].createElement(ContentContainer, {
        className: "flex rounded mt-3 p-2"
      }, !this.props.showCloseButton ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-0"
      }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
        buttonTheme: "buttonDanger",
        tabIndex: -1,
        onClick: function onClick(e) {
          return _this3.onHide();
        }
      }, this.props.closeLabel)), !filteredActions.length || Boolean(onResolve) || Boolean(onReject) ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1 flex justify-end"
      }, filteredActions.map(function (_ref2, i) {
        var label = _ref2.label,
            _ref2$buttonTheme = _ref2.buttonTheme,
            buttonTheme = _ref2$buttonTheme === void 0 ? "button" : _ref2$buttonTheme,
            _ref2$disabled = _ref2.disabled,
            disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
            url = _ref2.url,
            rest = _objectWithoutProperties(_ref2, ["label", "buttonTheme", "disabled", "url"]);

        return url === undefined ? /*#__PURE__*/_react["default"].createElement(_Button.Button, {
          onClick: function onClick(e) {
            return _this3.onAction(e, rest);
          },
          key: i,
          tabIndex: -1,
          disabled: disabled,
          buttonTheme: buttonTheme,
          className: "ml-1"
        }, label) : /*#__PURE__*/_react["default"].createElement(_Button.LinkButton, {
          to: url || "#",
          key: i,
          className: "ml-1",
          tabIndex: -1
        }, label);
      })))));
    }
  }]);

  return Modal;
}(_react["default"].Component);

_defineProperty(Modal, "defaultProps", {
  onHide: function onHide() {},
  show: false,
  actions: [],
  hideOnAction: true,
  closeLabel: "Close",
  usePositioned: false,
  showCloseButton: true
});

var _default = Modal;
exports["default"] = _default;

var BodyContainer = function BodyContainer(_ref3) {
  var children = _ref3.children;
  var theme = (0, _wrappers.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        body inline-block rounded p-3 ".concat(theme.accent2, "\n      ")
  }, children);
};

var ContentContainer = function ContentContainer(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? "" : _ref4$className,
      children = _ref4.children;
  var theme = (0, _wrappers.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      ".concat(theme.bg, " ").concat(className, "\n    ")
  }, children);
};